<template>
  <el-dialog
      :visible.sync="localDialogShow"
      width="50%"
      @close="handleClose">
    <div class="phone">
      <div class="title">登录/注册</div>
      <div class="message">

        <div>
          <span>手机号:</span>
          <el-input v-model="phone" placeholder="请输入手机号"></el-input>
        </div>
        <div style="display: flex !important;width: 450px;margin: 0 auto">
          <span style="display: block">短信验证码:</span>
          <div class="box">
            <el-input
                placeholder="请输入短信验证码"
                v-model="code"
            ></el-input>
            <div class="textNum" @click="sendCode" v-if="codeText === '发送验证码'">
              {{ codeText }}
            </div>
            <div class="text" @click="sendCode" v-else>
              {{ codeText }}
            </div>
          </div>
        </div>

      </div>

    </div>

    <div style="text-align: center;margin-top: 50px">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="warning" @click="confirmDialog">确 定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {phoneAndCodeLoginApi, sendCodeApi} from "@/http/api/user";

export default {
  name: 'loginDia',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localDialogShow: this.dialogShow, // 创建本地副本
      phone: '',
      code: '',
      name: '',
      codeText: '发送验证码',
    }
  },
  watch: {
    dialogShow(newVal) {
      this.localDialogShow = newVal; // 同步父组件变化
    }
  },
  methods: {
    // 手机验证
    validatePhone(phone) {
      // 中国大陆手机号校验
      const chineseRegex = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      // 国际手机号宽松校验（以+开头，4-15位数字）
      const internationalRegex = /^\+\d{4,15}$/;

      return chineseRegex.test(phone) || internationalRegex.test(phone);
    },
    // 发送验证码
    sendCode() {

      if (typeof this.codeText != "number") {

        if (!this.validatePhone(this.phone)) {
          this.$message.error("请输入正确的手机号"); // 提示用户
          return; // 终止执行
        }

        this.codeText = 60;
        var time = setInterval((res) => {
          if (this.codeText > 0) {
            this.codeText--;
          }
          if (this.codeText == 0) {
            clearInterval(time)
            this.codeText = '发送验证码';
          }
        }, 1000);

        //发送验证码
        sendCodeApi({
          phone: this.phone,
          type: "login",
        }).then((res) => {
          this.$message({
            type: "success",
            message: "短信发送成功",
          });
        });
      }
    },
    closeDialog() {
      this.phone = ''
      this.code = ''
      this.$emit('update:dialogShow', false);
    },
    confirmDialog() {
      // 这里可以添加确认逻辑
      phoneAndCodeLoginApi({
        phone: this.phone,
        code: this.code
      }).then(res => {
        console.log(res)
        if(res){

          this.phone = ''
          this.code = ''
          this.$store.dispatch('Login', res);
          this.$emit('update:dialogShow', false);
          this.$message.success('操作成功，即将登录')
          setTimeout(() => {
            this.$router.go(0) // 使用路由刷新
          }, 1000)
        }

      });

    },
    handleClose() {
      this.phone = ''
      this.code = ''
      this.codeText = '发送验证码'
      this.$emit('update:dialogShow', false);
    }
  }
}
</script>

<style lang="less" scoped>
/* 你的样式 */
.title {
  text-align: center;
  font-size: 20px;
  margin: 20px 0 20px;
}

.message {
  & > div {
    //display: flex;
    margin-bottom: 15px;
    align-items: center;
    text-align: center;

    .box {
      width: 320px;
      margin-left: 10px;
      height: 44px;
      background-color: #f8f8f8;

      border-radius: 6px;
      box-sizing: border-box;
      padding: 10px 0px;
      display: flex;

      .icon {
        width: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #d9d9d9;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .text {
        width: 100px;
        //display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #d9d9d9;
        font-size: 14px;
        color: #9b9b9b;
        line-height: 24px;

        &:hover {
          cursor: pointer;
        }
      }

      .textNum {
        width: 100px;
        //display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #d9d9d9;
        font-size: 14px;
        color: #E6A23C;

        line-height: 24px;

        &:hover {
          cursor: pointer;
        }
      }

      .el-input {
        flex: 1;

        /deep/ .el-input__inner {
          height: 24px;
          background-color: transparent;
          border-color: transparent;
        }
      }
    }

    span {
      width: 80px;
      text-align: right;
      font-size: 14px;

    }

    /deep/ .el-input {
      width: 320px;
      background-color: #f8f8f8;
      margin-left: 10px;
    }

    /deep/ .el-input__inner {
      background-color: #f8f8f8;
    }

    /deep/ .el-textarea {
      width: 320px;
      background-color: #f8f8f8;
      margin-left: 10px;
    }

    /deep/ .el-textarea__inner {
      background-color: #f8f8f8;
    }
  }
}

.custom-footer {
  display: flex;
  justify-content: center;
  gap: 20px; /* 按钮间距 */
}
</style>